// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.styled-table th,
.styled-table td {

  padding: 8px;
}

.styled-table th {
  background-color: #f2f2f2;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.sortable-header:hover {
  background-color: #e9ecef;
}

.badge.bg-success-app {
  background-color: #28a745;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Announcement/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".styled-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.styled-table th,\n.styled-table td {\n\n  padding: 8px;\n}\n\n.styled-table th {\n  background-color: #f2f2f2;\n  cursor: pointer;\n  user-select: none;\n}\n\n.sortable-header:hover {\n  background-color: #e9ecef;\n}\n\n.badge.bg-success-app {\n  background-color: #28a745;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
